import withAemIntegration from "../../../withAemIntegration";

const ComponentEditConfig = {
    emptyLabel: "Hot Spot Item",
    isEmpty: function (props) {
        return !props || !props.other || props.other.trim().length < 1;
    },
    aemNoDecoration: true,
};

const transformData = (props) => {
    const transformed = { ...props || {} };
    return transformed;
};

const HotSpotItem = (props) => {
    const data = transformData(props);

    const { editorMode = false } = window;
    if (editorMode) {
        return <div></div>;
    }
};

export default withAemIntegration("lexus/components/content/dynamic-content/dynamic-content-hotspot-item")(
    HotSpotItem,
    ComponentEditConfig
);
